import type { NavigateFunction } from 'react-router-dom';

/** Вкладки обзора журнала (`journal.tsx` → `tabs`). */
export const JOURNAL_TAB_ACTIVE_CLIENTS = 1;
export const JOURNAL_TAB_ARCHIVE_CLIENTS = 2;
export const JOURNAL_TAB_GROUP_THERAPY = 3;

export type JournalLocationState = {
  clientId?: number | string;
  isClientActive?: boolean;
  /** 1 — активные, 2 — архив, 3 — групповая терапия */
  journalTabId?: number;
  openSessionDetail?: {
    consultationId: number;
    initialTab: string;
  };
};

export function resolveJournalOverviewTab(state: JournalLocationState | null | undefined): number {
  const tabId = state?.journalTabId;
  if (
    tabId === JOURNAL_TAB_ACTIVE_CLIENTS ||
    tabId === JOURNAL_TAB_ARCHIVE_CLIENTS ||
    tabId === JOURNAL_TAB_GROUP_THERAPY
  ) {
    return tabId;
  }
  if (state?.clientId !== undefined) {
    return state.isClientActive === false ? JOURNAL_TAB_ARCHIVE_CLIENTS : JOURNAL_TAB_ACTIVE_CLIENTS;
  }
  return JOURNAL_TAB_ACTIVE_CLIENTS;
}

export function getClientIdFromEntity(clientEntity: string | undefined): number | undefined {
  const raw = clientEntity?.split('/').at(-1);
  const id = raw ? Number(raw) : undefined;
  return id !== undefined && !Number.isNaN(id) ? id : undefined;
}

export function buildOpenJournalSessionState(
  consultationId: number,
  clientEntity: string | undefined,
  initialTab: string,
  options?: { isClientActive?: boolean; journalTabId?: number },
): JournalLocationState {
  const clientId = getClientIdFromEntity(clientEntity);

  return {
    ...(clientId !== undefined
      ? { clientId, isClientActive: options?.isClientActive ?? true }
      : {}),
    ...(options?.journalTabId !== undefined ? { journalTabId: options.journalTabId } : {}),
    openSessionDetail: { consultationId, initialTab },
  };
}

export function navigateToJournalSession(
  navigate: NavigateFunction,
  consultationId: number,
  clientEntity: string | undefined,
  initialTab: string,
  options?: { isClientActive?: boolean; journalTabId?: number; replace?: boolean },
) {
  navigate('/journal', {
    replace: options?.replace,
    state: buildOpenJournalSessionState(consultationId, clientEntity, initialTab, options),
  });
}
